// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input,
textarea,
option {
  outline: none;
  border: none;
}

/* -----------------------------------------------------------------------------
// CUADRO LOGIN
// ----------------------------------------------------------------------------- */
.login {
  top: 0;
  right: 0;
  z-index: 3000;
  width: fit-content;
  height: 120px;
  padding: 20px 25px;
}

.login .campo label,
.login .campo input::placeholder {
  font-size: 14px;
}

.login .campo input {
  padding: 5px 5px 1px 5px;
  border-bottom: 1px solid white;
}

.login .campo .ojo svg {
  margin-left: -10px;
}
.login .campo input::placeholder {
  color: rgba(255, 255, 255, 0.884);
}

.contraseña-olvidada {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  display: inline-block;
}

.login .botones-terminos {
  justify-content: space-between;
  width: 365px;
}

.login .terminos input[type="checkbox"] {
  margin-right: 0.5rem;
  width: 12px;
  height: 12px;
  cursor: pointer;
}

.login .terminos label,
.login .terminos a {
  font-size: 14px;
}

.login .botones {
  align-items: baseline;
}

.login .botones .iniciar {
  color: #fff;
  background-color: #007932;
  border-radius: 12px;
  border: 2px solid #fff;
  padding: 6px 30px;
}

.login .botones .iniciar:hover {
  background-color: #ffffff;
  color: #007932;
}

/* 2FA form */
.twofa-form {
  gap: 1rem;
}
.twofa-form label {
  font-weight: bold;
}

.twofa-form input {
  padding: 0.5rem;
  border-radius: 4px;
}

.password-container .input-with-icon input {
  padding-right: 2rem;
}

.password-container .ojo {
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.error-message {
  height: 40px;
  width: 100%;
  top: 120px;
  left: 0px;
  background-color: #ffdddd;
  color: #d8000c;
  padding: 0.5rem 1rem;
  border: 1px solid #d8000c;
  border-radius: 4px;
}

.success-message {
  height: 40px;
  width: 100%;
  top: 120px;
  left: 0px;
  background-color: #e1ffdd;
  color: #1d9200;
  padding: 0.5rem 1rem;
  border: 1px solid #1d9200;
  border-radius: 4px;
}

/* -----------------------------------------------------------------------------
// FORMULARIO REGISTRO
// ----------------------------------------------------------------------------- */
.formulario-registro {
  left: 0;
  top: 140px;
  bottom: 0px;
  right: 0px;
  position: fixed;
  background-color: #00000080;
  z-index: 999;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-y: auto; /* Ensure vertical scroll when needed */
  padding-top: 50px; /* Add padding for visual spacing */
  padding-bottom: 50px; /* Add padding for visual spacing */
}

.formulario-registro .formulario {
  padding: 25px 75px 25px 50px;
  gap: 1.5rem;
  width: 1200px;
  max-width: 90%;
  border-radius: 10px;
  position: relative; /* Changed from having top: 50px */
  margin-top: auto; /* Center when there's enough space */
  margin-bottom: auto; /* Center when there's enough space */
}

.formulario-registro .formulario label,
.formulario-registro .formulario .campo p {
  gap: 5px;
}

.formulario-registro .cerrar {
  top: 10px;
  right: 10px;
  text-decoration: none;
  padding: 10px 10px 5px 10px;
  border: 2px solid #fff;
  border-radius: 8px;
}

.formulario-registro .cerrar svg {
  font-size: 21px;
}
.formulario-registro .cerrar:hover {
  border: 2px solid #007932;
}

.linea {
  margin: 10px 0px;
  gap: 50px 25px;
  justify-content: space-between;
}

.formulario-registro .campo input::placeholder,
.formulario-registro .campo textarea::placeholder,
.formulario-registro .campo select::placeholder {
  color: #666;
}

.campo select,
.password-field {
  outline: none;
  border: none;
  border-bottom: 1px solid #007932;
  margin-top: 9px;
}

.linea .campo input[type="text"],
.linea .campo input[type="email"],
.linea .campo input[type="tel"],
.linea .campo input[type="number"] {
  border: none;
  border-bottom: 1px solid #007932;
  padding: 5px 5px 1px 2.5px;
  outline: none;
}

.campo textarea {
  border: 1px solid #007932;
  border-radius: 10px;
  padding: 10px;
}

.formulario-registro .checkbox {
  gap: 7.5px;
}

.formulario-registro .terminos label {
  font-size: 14px;
  margin-left: 7.5px;
}

.formulario-registro .terminos label a {
  color: #007932;
  font-size: 14px;
}

.formulario-registro .error-message {
  color: red;
  font-size: 14px;
  white-space: nowrap; /* Evita que el mensaje se rompa en varias líneas */
  margin-bottom: 0px;
  text-align: center;
}

.terminos-enviar {
  margin-top: 10px;
  padding-top: 20px;
  border-top: 1px solid #007932;
}

.formulario-registro button[type="submit"] {
  align-self: flex-end;
  border: 1px solid #007932;
  border-radius: 10px;
  padding: 0.6rem 1.2rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 200px !important;
}

.formulario-registro button[type="submit"]:hover {
  background-color: #007932;
  color: white;
}

@media (max-width: 820px) {
  .formulario-registro {
    top: 100px;
  }
}

@media (max-width: 540px) {
  .formulario-registro .formulario {
    padding: 25px 20px 25px 20px;
  }

  .formulario-registro .linea {
    row-gap: 30px;
  }

  .formulario-registro .linea > div {
    flex-grow: 1;
  input:not([type="checkbox"]) {
    width: 100%;
  }
  select {
    padding: 10px;
  }
  }

  .formulario-registro  .terminos-enviar{
    flex-wrap: wrap;
    row-gap: 40px;
    .error-boton-container{
    margin: 0 auto;
    }
  }

  .formulario-registro .terminos label {
    line-height: 1.1;
    a{
      line-height: 1;
    }
  }

}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/login-registro.css"],"names":[],"mappings":"AAAA;;;EAGE,aAAa;EACb,YAAY;AACd;;AAEA;;kFAEkF;AAClF;EACE,MAAM;EACN,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;kFAEkF;AAClF;EACE,OAAO;EACP,UAAU;EACV,WAAW;EACX,UAAU;EACV,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB,EAAE,uCAAuC;EACzD,iBAAiB,EAAE,mCAAmC;EACtD,oBAAoB,EAAE,mCAAmC;AAC3D;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB,EAAE,kCAAkC;EACtD,gBAAgB,EAAE,qCAAqC;EACvD,mBAAmB,EAAE,qCAAqC;AAC5D;;AAEA;;EAEE,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB,EAAE,mDAAmD;EACxE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;;EAEA;IACE,eAAe;IACf,aAAa;IACb;IACA,cAAc;IACd;EACF;;EAEA;IACE,gBAAgB;IAChB;MACE,cAAc;IAChB;EACF;;AAEF","sourcesContent":["input,\ntextarea,\noption {\n  outline: none;\n  border: none;\n}\n\n/* -----------------------------------------------------------------------------\n// CUADRO LOGIN\n// ----------------------------------------------------------------------------- */\n.login {\n  top: 0;\n  right: 0;\n  z-index: 3000;\n  width: fit-content;\n  height: 120px;\n  padding: 20px 25px;\n}\n\n.login .campo label,\n.login .campo input::placeholder {\n  font-size: 14px;\n}\n\n.login .campo input {\n  padding: 5px 5px 1px 5px;\n  border-bottom: 1px solid white;\n}\n\n.login .campo .ojo svg {\n  margin-left: -10px;\n}\n.login .campo input::placeholder {\n  color: rgba(255, 255, 255, 0.884);\n}\n\n.contraseña-olvidada {\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n  display: inline-block;\n}\n\n.login .botones-terminos {\n  justify-content: space-between;\n  width: 365px;\n}\n\n.login .terminos input[type=\"checkbox\"] {\n  margin-right: 0.5rem;\n  width: 12px;\n  height: 12px;\n  cursor: pointer;\n}\n\n.login .terminos label,\n.login .terminos a {\n  font-size: 14px;\n}\n\n.login .botones {\n  align-items: baseline;\n}\n\n.login .botones .iniciar {\n  color: #fff;\n  background-color: #007932;\n  border-radius: 12px;\n  border: 2px solid #fff;\n  padding: 6px 30px;\n}\n\n.login .botones .iniciar:hover {\n  background-color: #ffffff;\n  color: #007932;\n}\n\n/* 2FA form */\n.twofa-form {\n  gap: 1rem;\n}\n.twofa-form label {\n  font-weight: bold;\n}\n\n.twofa-form input {\n  padding: 0.5rem;\n  border-radius: 4px;\n}\n\n.password-container .input-with-icon input {\n  padding-right: 2rem;\n}\n\n.password-container .ojo {\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.error-message {\n  height: 40px;\n  width: 100%;\n  top: 120px;\n  left: 0px;\n  background-color: #ffdddd;\n  color: #d8000c;\n  padding: 0.5rem 1rem;\n  border: 1px solid #d8000c;\n  border-radius: 4px;\n}\n\n.success-message {\n  height: 40px;\n  width: 100%;\n  top: 120px;\n  left: 0px;\n  background-color: #e1ffdd;\n  color: #1d9200;\n  padding: 0.5rem 1rem;\n  border: 1px solid #1d9200;\n  border-radius: 4px;\n}\n\n/* -----------------------------------------------------------------------------\n// FORMULARIO REGISTRO\n// ----------------------------------------------------------------------------- */\n.formulario-registro {\n  left: 0;\n  top: 140px;\n  bottom: 0px;\n  right: 0px;\n  position: fixed;\n  background-color: #00000080;\n  z-index: 999;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  overflow-y: auto; /* Ensure vertical scroll when needed */\n  padding-top: 50px; /* Add padding for visual spacing */\n  padding-bottom: 50px; /* Add padding for visual spacing */\n}\n\n.formulario-registro .formulario {\n  padding: 25px 75px 25px 50px;\n  gap: 1.5rem;\n  width: 1200px;\n  max-width: 90%;\n  border-radius: 10px;\n  position: relative; /* Changed from having top: 50px */\n  margin-top: auto; /* Center when there's enough space */\n  margin-bottom: auto; /* Center when there's enough space */\n}\n\n.formulario-registro .formulario label,\n.formulario-registro .formulario .campo p {\n  gap: 5px;\n}\n\n.formulario-registro .cerrar {\n  top: 10px;\n  right: 10px;\n  text-decoration: none;\n  padding: 10px 10px 5px 10px;\n  border: 2px solid #fff;\n  border-radius: 8px;\n}\n\n.formulario-registro .cerrar svg {\n  font-size: 21px;\n}\n.formulario-registro .cerrar:hover {\n  border: 2px solid #007932;\n}\n\n.linea {\n  margin: 10px 0px;\n  gap: 50px 25px;\n  justify-content: space-between;\n}\n\n.formulario-registro .campo input::placeholder,\n.formulario-registro .campo textarea::placeholder,\n.formulario-registro .campo select::placeholder {\n  color: #666;\n}\n\n.campo select,\n.password-field {\n  outline: none;\n  border: none;\n  border-bottom: 1px solid #007932;\n  margin-top: 9px;\n}\n\n.linea .campo input[type=\"text\"],\n.linea .campo input[type=\"email\"],\n.linea .campo input[type=\"tel\"],\n.linea .campo input[type=\"number\"] {\n  border: none;\n  border-bottom: 1px solid #007932;\n  padding: 5px 5px 1px 2.5px;\n  outline: none;\n}\n\n.campo textarea {\n  border: 1px solid #007932;\n  border-radius: 10px;\n  padding: 10px;\n}\n\n.formulario-registro .checkbox {\n  gap: 7.5px;\n}\n\n.formulario-registro .terminos label {\n  font-size: 14px;\n  margin-left: 7.5px;\n}\n\n.formulario-registro .terminos label a {\n  color: #007932;\n  font-size: 14px;\n}\n\n.formulario-registro .error-message {\n  color: red;\n  font-size: 14px;\n  white-space: nowrap; /* Evita que el mensaje se rompa en varias líneas */\n  margin-bottom: 0px;\n  text-align: center;\n}\n\n.terminos-enviar {\n  margin-top: 10px;\n  padding-top: 20px;\n  border-top: 1px solid #007932;\n}\n\n.formulario-registro button[type=\"submit\"] {\n  align-self: flex-end;\n  border: 1px solid #007932;\n  border-radius: 10px;\n  padding: 0.6rem 1.2rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  width: 200px !important;\n}\n\n.formulario-registro button[type=\"submit\"]:hover {\n  background-color: #007932;\n  color: white;\n}\n\n@media (max-width: 820px) {\n  .formulario-registro {\n    top: 100px;\n  }\n}\n\n@media (max-width: 540px) {\n  .formulario-registro .formulario {\n    padding: 25px 20px 25px 20px;\n  }\n\n  .formulario-registro .linea {\n    row-gap: 30px;\n  }\n\n  .formulario-registro .linea > div {\n    flex-grow: 1;\n  input:not([type=\"checkbox\"]) {\n    width: 100%;\n  }\n  select {\n    padding: 10px;\n  }\n  }\n\n  .formulario-registro  .terminos-enviar{\n    flex-wrap: wrap;\n    row-gap: 40px;\n    .error-boton-container{\n    margin: 0 auto;\n    }\n  }\n\n  .formulario-registro .terminos label {\n    line-height: 1.1;\n    a{\n      line-height: 1;\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
